<template>
  <div style="margin-top: 8rem;">
    <svg style="margin-bottom: -7px; margin-left: calc((100% - 100vw)/2); width: 100vw;" viewBox="0 0 1920 95" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M495 0C341.855 0 80.4985 20.2439 0 40.539V95H1920V73.0329C1883.32 58.7065 1796.62 40.539 1639.24 40.539C1447.84 40.539 1394.55 65.7323 1256.5 65.7323C1049.09 65.7323 915.813 0 495 0Z" fill="#666260"/>
    </svg>
    <div class="text-white text-left pb-10 pt-5 fit-width" style="background-color: #666260; color: #DBDBDB">
        <img alt="Logo SARAH" style="width: 483px;" src="../assets/logos/LogoSARAH_completaBRANCA_1.png">
        <br/>
        <br/>
        <br/>
        <div style="padding-left: 18px;">
          <div class="inline-block w-1/4">
              <p><a target="_blank" href="https://www.sarah.br" class="text-white" style="font-size: 14px; text-decoration: none;">sarah.br</a></p>
              <p><a target="_blank" href="mailto:prevencao@sarah.br" class="text-white" style="font-size: 14px; text-decoration: none;">prevencao@sarah.br</a></p>
          </div>
          <div class="inline-block w-1/2 footer-desc--desktop">
              <p style="font-size: 14px;">A Rede SARAH de Hospitais de Reabilitação é mantida pela Associação das Pioneiras Sociais (APS), órgão instituído pela Lei nº 8.246/91, de 22 Outubro de 1991. Está presente em oito capitais brasileiras e realiza mais de 19 milhões de procedimentos por ano. Tem por meta principal oferecer serviços de saúde pública de alta qualidade com excelência, com tecnologia de ponta e humanismo, à todos os níveis da população, nas áreas ortopédica e neurológica.</p>
          </div>
          <div class="inline-block footer-desc--mobile">
              <p style="font-size: 14px;">A Rede SARAH de Hospitais de Reabilitação é mantida pela Associação das Pioneiras Sociais (APS), órgão instituído pela Lei nº 8.246/91, de 22 Outubro de 1991. Está presente em oito capitais brasileiras e realiza mais de 19 milhões de procedimentos por ano. Tem por meta principal oferecer serviços de saúde pública de alta qualidade com excelência, com tecnologia de ponta e humanismo, à todos os níveis da população, nas áreas ortopédica e neurológica.</p>
          </div>
          <br/>
          <br/>
          <p>©Associação das Pioneiras Sociais</p>
        </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
p {
  font-size: 18px;
}

.footer-desc--desktop {
  display: none;
}

@media (min-width: 768px) {
  .footer-desc--desktop {
    display: inline-block;
  }
  .footer-desc--mobile {
    display: none;
  }
}
</style>